module.exports = __webpack_public_path__ + "img/vertical_3_1_3.1f9fca55.png";